import React from "react";
import Section from "@atoms/Section/Section";
import Title from "@atoms/Title/Title";
import TitleGroup from "@atoms/TitleGroup/TitleGroup";
import Module from "@atoms/Module/Module";
import CardSlider from "@components/CardSlider/CardSlider";
import { Box } from "@material-ui/core";
import Icon from "@atoms/Icon/Icon";
import { SwiperSlide } from "swiper/react";
import "./CardSliderWithImageBackground.scss";
import { FaArrowRight } from "react-icons/fa";
import CardWithBackground from "../Card/CardWithBackground";
import "./RelatedContentWithImg.scss";

const RelatedContentWithImg = ({ title, components }) => {
	const relatedContentData = components ? components[0] : undefined;
	const cards = relatedContentData ? relatedContentData?.component : [];

	return (
		<>
			<Section spacing="m" container="large" className="RelatedContentWithImg">
				<TitleGroup title={title} />
				<CardSlider
					sliderName="RelatedContentWithImg"
					hideOverflow
					hasNavigation
					sliderOption={{
						slidesPerView: 1.3,
						a11y: false,
						preventClicksPropagation: true,
						threshold: 20,
						breakpoints: {
							slidesOffsetAfter: 20,
							slidesOffsetBefore: 20,
							501: {
								slidesPerView: 1.3,
								spaceBetween: 16,
							},
							801: {
								slidesPerView: 2.3,
								spaceBetween: 16,
							},
							1001: {
								slidesPerView: 3.3,
							},
						},
					}}
				>
					{cards.map((item) => (
						<SwiperSlide key={item.button?.label}>
							<Module padding="none" radius="giant">
								<CardWithBackground
									url={item.images ? item.images[0]?.src?.url : ""}
									urlSharp={
										item.images[0]?.src?.urlSharp
											? item.images[0]?.src?.urlSharp
											: undefined
									}
									greenBackground
								>
									<a href={item.button?.to}>
										<Box
											display="flex"
											justifyContent="space-between"
											flexDirection="column"
											sx={{
												height: "100%",
											}}
										>
											<Title size="l" theme="white">
												{item.button?.label}
											</Title>
											<Icon icon={<FaArrowRight />} size="s" theme="white" />
										</Box>
									</a>
								</CardWithBackground>
							</Module>
						</SwiperSlide>
					))}
				</CardSlider>
			</Section>
		</>
	);
};

export default RelatedContentWithImg;
